import { Button } from 'react-bootstrap';
import React from 'react';
import './Avatar.css';

export default function Avatar(props) {
    const colors = ['orange', 'green', 'yellow', 'pink'];
    const color = colors[Math.floor(Math.random()*colors.length)];

    return (
        <Button className={"btn btn-circle btn-avatar-"+color}>{props.name}</Button>
    );
}
